import React, { useEffect } from 'react'
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import useAuth from '../../hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { setCredentials } from '../../redux/slices/authSlice';
import Loader from '../Loader';


const LoginRedirect = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setAuth, persist, setPersist } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();

    let error = searchParams.get('error');
    let accessToken = searchParams.get('accessToken');
    let refreshToken = searchParams.get('refreshToken');
    let content;

    useEffect(() => {
        if (accessToken && refreshToken) {
            let user = jwtDecode(accessToken);
            // console.log('user', user);
            // console.log('persist', persist);
            setAuth({ user: user, accessToken: accessToken, refreshToken: refreshToken });
            setPersist(true);
            dispatch(setCredentials({ refreshToken: refreshToken, accessToken: accessToken, user: user }));
        }
    }, [accessToken, refreshToken])

    useEffect(() => {
        localStorage.setItem('persist', persist);
    }, [persist])

    if (error) {
        content = (
            <div>
                Error!
                <p>{JSON.stringify(error, null, 2)}</p>
            </div>
        )
    } else if (accessToken && refreshToken) {

        setTimeout(() => {
            navigate('/', { replace: true })
        }, 2000);
        content = (
            <Loader />
        )
    } else {
        content = (
            <Loader />
        )
    }




    return content;
}

export default LoginRedirect
